import {
  EXAM_CENTER_MEMBER_STATUS_COLOR,
  EXAM_CENTER_MEMBER_STATUS_TEXT,
  UserAvatar,
  type ExamCenterMemberStatus,
} from '@exam-center/exam-center-member-details';
import { ChipGroup, Flex, Label, Text, type GridColDef } from '@shared/components';
import { formatDateTime } from '@shared/utils';

export interface ExamCenterMemberListItem {
  id: string;
  order: number;
  roles: string[];
  fullName: string;
  email: string;
  lastLoginAt: string;
  status: ExamCenterMemberStatus;
}

export const columns: GridColDef<ExamCenterMemberListItem>[] = [
  {
    field: 'order',
    headerName: 'No',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
    width: 60,
  },
  {
    field: 'name',
    headerName: 'Name',
    sortable: false,
    flex: 1,
    renderCell: (params) => {
      const { fullName, email } = params.row;
      return (
        <Flex sx={{ gap: (theme) => theme.spacing(3), alignItems: 'center' }}>
          <UserAvatar fullName={fullName} email={email} />
          <Flex sx={{ flexDirection: 'column' }}>
            <Text variant='body1Semibold'>{fullName}</Text>
            <Text variant='body2' color='textSecondary'>
              {email}
            </Text>
          </Flex>
        </Flex>
      );
    },
  },
  {
    field: 'type',
    headerName: 'Role',
    sortable: false,
    width: 240,
    renderCell: (params) => {
      const { roles } = params.row;
      return <ChipGroup labels={roles} limit={2} />;
    },
  },
  {
    field: 'lastLoginAt',
    headerName: 'Last Login',
    sortable: false,
    width: 160,
    valueFormatter: (params) => {
      return `${params.value ? formatDateTime(params.value) : '-'}`;
    },
  },
  {
    field: 'status',
    headerName: 'Status',
    sortable: false,
    width: 120,
    renderCell: (params) => {
      const { status } = params.row;
      return (
        <Label color={EXAM_CENTER_MEMBER_STATUS_COLOR[status]}>
          {EXAM_CENTER_MEMBER_STATUS_TEXT[status]}
        </Label>
      );
    },
  },
];
